<template>
  <div>
    <h1>Vat create</h1>
    <v-btn :to="{ name: 'vatActions' }">
      <v-icon>chevron_left</v-icon>Vat actions
    </v-btn>
    <v-select
      label="Action"
      v-model="action"
      :items="actions"
      item-value="action"
      item-text="name"
    />
    <v-select
      label="Vat registration number"
      v-model="vrn"
      :items="vrns"
      item-value="vrn"
      item-text="name"
    />
    <v-text-field
      label="Penalty Charge Reference"
      v-model="penaltyChargeReference"
      v-if="action === 'retrieveFinancialDetails'"
    />
    <template
      v-if="
        action === 'retrieveVatLiabilities' ||
        action === 'retrieveVatObligations' ||
        action === 'retrieveVatPayments'
      "
    >
      <v-date-picker v-model="from" />
      <v-date-picker v-model="to" />
    </template>
    <v-select
      label="Status"
      v-model="status"
      :items="statuses"
      item-value="value"
      item-text="name"
      v-if="action === 'retrieveVatObligations'"
    />
    <v-text-field
      label="Period Key"
      v-model="periodKey"
      v-if="action === 'submitVatReturnForPeriod' || action === 'viewVatReturn'"
    />
    <template v-if="action === 'submitVatReturnForPeriod'">
      <v-text-field type="number" label="Vat Due Sales" v-model="vatDueSales" />
      <v-text-field
        type="number"
        label="Vat Due Acquisitions"
        v-model="vatDueAcquisitions"
      />
      <v-text-field type="number" label="Total Vat Due" v-model="totalVatDue" />
      <v-text-field
        type="number"
        label="Vat Reclaimed Curr Period"
        v-model="vatReclaimedCurrPeriod"
      />
      <v-text-field type="number" label="Net Vat Due" v-model="netVatDue" />
      <v-text-field
        type="number"
        label="Total Value Sales Ex VAT"
        v-model="totalValueSalesExVAT"
      />
      <v-text-field
        type="number"
        label="Total Value Purchases Ex VAT"
        v-model="totalValuePurchasesExVAT"
      />
      <v-text-field
        type="number"
        label="Total Value Goods Supplied Ex VAT"
        v-model="totalValueGoodsSuppliedExVAT"
      />
      <v-text-field
        type="number"
        label="Total Acquisitions Ex VAT"
        v-model="totalAcquisitionsExVAT"
      />
      <v-checkbox label="Finalised" v-model="finalised" />
    </template>
    <v-select
      v-if="testScenarios"
      label="Test scenario"
      v-model="testScenario"
      :items="testScenarios"
    />
    <a @click="createVat">Start submission process</a>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import CREATE_VAT from "@/graphql/accounts/vat/CreateVat";
import CREATE_VATTOKEN from "@/graphql/accounts/vat/CreateVatToken";
import VATTOKEN from "@/graphql/accounts/vat/VatToken";
import { getClientHeaders } from "../../util/helpers";
export default {
  name: "VatCreate",
  metaInfo() {
    return {
      title: "Vat create",
      titleTemplate: "%s - Accounts - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    test() {
      return this.$route.query.test ? true : false;
    },
    testScenarios() {
      if (!this.test) {
        return undefined;
      }
      const action = this.actions.find((a) => a.action === this.action);
      return action ? action.testScenarios : undefined;
    },
    redirectUri() {
      return this.test
        ? `${process.env.VUE_APP_MY_URL}/vatCreate?test=${this.test}`
        : `${process.env.VUE_APP_MY_URL}/vatCreate`;
    },
    vrns() {
      return this.test
        ? [
            { name: "Company ZYPZDK", vrn: 140793274 },
            { name: "Company TWAICX", vrn: 112307524 }
          ]
        : [{ name: "Nigel Broadhead Mynard", vrn: 418324464 }];
    }
  },
  data() {
    return {
      vrn: null,
      actions: [
        {
          name: "Get Feedback On Requests Made To An Api",
          action: "getFeedbackOnRequestsMadeToAnApi"
        },
        {
          name: "Retrieve Financial Details",
          action: "retrieveFinancialDetails",
          testScenarios: ["-"]
        },
        {
          name: "Retrieve Vat Liabilities",
          action: "retrieveVatLiabilities",
          testScenarios: [
            "-",
            "SINGLE_LIABILITY",
            "MULTIPLE_LIABILITIES",
            "SINGLE_LIABILITY_2018_19",
            "MULTIPLE_LIABILITIES_2018_19",
            "INSOLVENT_TRADER"
          ]
        },
        {
          name: "Retrieve Vat Obligations",
          action: "retrieveVatObligations",
          testScenarios: [
            "-",
            "QUARTERLY_NONE_MET",
            "QUARTERLY_ONE_MET",
            "QUARTERLY_TWO_MET",
            "QUARTERLY_THREE_MET",
            "QUARTERLY_FOUR_MET",
            "MONTHLY_NONE_MET",
            "MONTHLY_ONE_MET",
            "MONTHLY_TWO_MET",
            "MONTHLY_THREE_MET",
            "MONTHLY_OBS_##_OPEN",
            "MONTHLY_OBS_12_FULFILLED",
            "QUARTERLY_OBS_##_OPEN",
            "QUARTERLY_OBS_04_FULFILLED",
            "MULTIPLE_OPEN_MONTHLY",
            "MULTIPLE_OPEN_QUARTERLY",
            "OBS_SPANS_MULTIPLE_YEARS",
            "INSOLVENT_TRADER",
            "NOT_FOUND"
          ]
        },
        {
          name: "Retrieve Vat Payments",
          action: "retrieveVatPayments",
          testScenarios: [
            "-",
            "SINGLE_PAYMENT",
            "MULTIPLE_PAYMENTS",
            "SINGLE_PAYMENT_2018_19",
            "MULTIPLE_PAYMENTS_2018_19",
            "INSOLVENT_TRADER"
          ]
        },
        {
          name: "Retrieve Vat Penalties",
          action: "retrieveVatPenalties",
          testScenarios: [
            "-",
            "NO_PENALTIES",
            "LATE_SUBMISSION",
            "LATE_PAYMENT",
            "MULTIPLE_PENALTIES",
            "MULTIPLE_LATE_PAYMENT_PENALTIES",
            "MULTIPLE_LATE_SUBMISSION_PENALTIES",
            "THRESHOLD_LATE_SUBMISSION_PENALTIES",
            "CHARGE_LATE_SUBMISSION_PENALTIES"
          ]
        },
        {
          name: "Submit Vat Return For Period",
          action: "submitVatReturnForPeriod",
          testScenarios: [
            "-",
            "INVALID_VRN",
            "INVALID_PERIODKEY",
            "INVALID_PAYLOAD",
            "DUPLICATE_SUBMISSION",
            "TAX_PERIOD_NOT_ENDED",
            "INSOLVENT_TRADER"
          ]
        },
        {
          name: "Validate Fraud Prevention Headers",
          action: "validateFraudPreventionHeaders"
        },
        {
          name: "View Vat Return",
          action: "viewVatReturn",
          testScenarios: ["-", "DATE_RANGE_TOO_LARGE", "INSOLVENT_TRADER"]
        }
      ],
      action: null,
      testScenario: null,
      statuses: [
        { name: "Open", value: "O" },
        { name: "Fulfilled", value: "F" }
      ],
      penaltyChargeReference: null,
      from: null,
      to: null,
      status: null,
      periodKey: null,
      vatDueSales: 0,
      vatDueAcquisitions: 0,
      totalVatDue: 0,
      vatReclaimedCurrPeriod: 0,
      netVatDue: 0,
      totalValueSalesExVAT: 0,
      totalValuePurchasesExVAT: 0,
      totalValueGoodsSuppliedExVAT: 0,
      totalAcquisitionsExVAT: 0,
      finalised: false,
      snackbar: false,
      snackbarText: null
    };
  },
  methods: {
    async fetchVatToken() {
      const response = await this.$apollo.query({
        query: VATTOKEN,
        variables: {
          test: this.test
        }
      });
      return response.data.vatToken;
    },
    async createVat() {
      try {
        const clientHeaders = getClientHeaders();
        const payload = this.getPayload();
        Object.keys(payload).forEach(function (key) {
          const value = payload[key];
          if (value === undefined || value === null || value === "") {
            throw new Error(`${key} is not set`);
          }
        });
        const response = await this.$apollo.mutate({
          mutation: CREATE_VAT,
          variables: {
            test: this.test,
            testScenario: this.testScenario,
            vrn: this.vrn,
            action: this.action,
            payload,
            clientHeaders
          }
        });
        const id = response.data.createVat.id;
        this.$router.push({
          name: "vatAction",
          params: {
            id
          }
        });
      } catch (err) {
        this.snackbar = true;
        this.snackbarText = err.message;
      }
    },
    getPayload() {
      if (this.action === "retrieveFinancialDetails") {
        return {
          penaltyChargeReference: this.penaltyChargeReference
        };
      } else if (this.action === "retrieveVatLiabilities") {
        return {
          from: this.from,
          to: this.to
        };
      } else if (this.action === "retrieveVatObligations") {
        return {
          from: this.from,
          to: this.to,
          status: this.status
        };
      } else if (this.action === "retrieveVatPayments") {
        return {
          from: this.from,
          to: this.to
        };
      } else if (this.action === "submitVatReturnForPeriod") {
        return {
          periodKey: this.periodKey,
          vatDueSales: this.vatDueSales,
          vatDueAcquisitions: this.vatDueAcquisitions,
          totalVatDue: this.totalVatDue,
          vatReclaimedCurrPeriod: this.vatReclaimedCurrPeriod,
          netVatDue: this.netVatDue,
          totalValueSalesExVAT: this.totalValueSalesExVAT,
          totalValuePurchasesExVAT: this.totalValuePurchasesExVAT,
          totalValueGoodsSuppliedExVAT: this.totalValueGoodsSuppliedExVAT,
          totalAcquisitionsExVAT: this.totalAcquisitionsExVAT,
          finalised: this.finalised
        };
      } else if (this.action === "viewVatReturn") {
        return {
          periodKey: this.periodKey
        };
      }
      return { empty: "There is nothing here!" };
    },
    requestOauthCode() {
      const client_id = this.test
        ? process.env.VUE_APP_HMRC_OAUTH_TEST_CLIENTID
        : process.env.VUE_APP_HMRC_OAUTH_CLIENTID;
      const baseurl = this.test
        ? process.env.VUE_APP_HMRC_OAUTH_TEST_BASEURL
        : process.env.VUE_APP_HMRC_OAUTH_BASEURL;
      const urlSearchParams = new URLSearchParams({
        response_type: "code",
        client_id,
        scope: "read:vat+write:vat",
        // state: vatid,
        redirect_uri: this.redirectUri
      });
      const url = `${baseurl}/oauth/authorize?${urlSearchParams}`;
      //   console.log(url);
      window.location.href = url;
    },
    async createVatToken() {
      const response = await this.$apollo.mutate({
        mutation: CREATE_VATTOKEN,
        variables: {
          test: this.test,
          redirectUri: this.redirectUri,
          code: this.$route.query.code
        }
      });
      return response.data.createVatToken;
    }
  },
  watch: {
    "$route.query.code": {
      immediate: true,
      handler() {
        if (this.$route.query.code) {
          this.createVatToken();
        }
      }
    },
    action: {
      handler() {
        this.testScenario = null;
      }
    }
  },
  created: async function () {
    if (this.$route.query.code) {
      return;
    }
    const isVatToken = await this.fetchVatToken();
    if (!isVatToken) {
      this.requestOauthCode();
    }
  }
};
</script>
